import Vue from 'vue'
import Vuex from 'vuex'
import { reqGetEncodeInfo } from '@/network'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    encode: window.sessionStorage.getItem('encode'),
    encodeInfo: {}
  },
  mutations: {
    setEncode(state, value) {
      window.sessionStorage.setItem('encode', value)
      state.encode = value
    },
    setEncodeInfo(state, value) {
      // value.zhangtao = value.zhangtao === '硬速' ? '硬速科技' : value.zhangtao
      state.encodeInfo = value
    }
  },
  actions: {
    async getEncodeInfo(context) {
      if (!context.state.encode) return
      const { data } = await reqGetEncodeInfo(context.state.encode)
      context.commit('setEncodeInfo', data)
    }
  },
  modules: {}
})
